export const MENU = {
  CASA_CENTRAL: {
    ACUERDOS: 78,
  },
  FILIALES: {
    AUTORIZACIONES: 8,
  },
  CLIENTES: {
    ACUERDOS: 10,
  },
  ARTICULOS: {

  },
  SISTEMA: {
    SOLICITUDES: 77,
  },
  LOGISTICA: {

  },
  VENTA: {
    
  },
  AUTOMATICOS: {
    CPBTES_PENDIENTES: 95, // + automaticos sin conciliar
    SALDO_PENDIENTE: 216, // + automaticos
  },
  FONDOS: {
    SALDO_CONSOLIDADO: 94,
    SALDO_PENDIENTE: 215,
    CPBTES_PENDIENTES: 85,
  },
  HEADER: {
    DASHBOARD: 1,
    CLIENTES: 9,
    SEGUIMIENTO: 24,
    PEDIDOS: 75,
    INDICES: 76,
  }
}

export const TAB_FILIALES = {
  DATOS: 33,
  DOMICILIOS: 34,
  HORARIOS: 35,
  CONTACTOS: 36,
  COBERTURA: 37,
  ZONAS: 38,
  LOCALIDADES: 39,
  DISTANCIAS: 40,
  EXCLUSIONES: 41,
  SEGUROS: 42,
  CONTRATO: 43,
  TAB_CONTRATO: {
    CONTRATOS: 86,
    TITULARES: 87,
    FIRMANTES: 88,
    COMISIONES: 89,
  },
  CONTRATISTAS: 44,
  VEHICULOS: 45,
  PERSONAL: 46,
  TAB_PERSONAL: {
    EMPLEADOS: 90,
    DISTRIBUIDORES: 91,
  },
  CANALIZACION: 208,
  CAJAS: 211,
}

export const TAB_CLIENTES = {
  DATOS: 48,
  DOMICILIOS: 49,
  PTOS_ENTREGA: 50,
  ENTREGA_RETIRO: 51,
  CONTACTOS: 52,
  FRECUENTES: 53,
  CTA_CTE: 54,
  REMITOS: 55,
  REDESPACHOS: 56,
  SEGUROS: 57,
  POLIZAS: 58,
  RUBROS: 59,
  VENDEDORES: 60,
  PROPIEDADES: 61,
  AUTOGESTION: 245,
  ACUERDOS: 246,
}

export const BUTTON = {
  DOCUMENTACION: 47,
  COMPLETAR_DISTRIBUCION: 232,
  EXIGENCIAS_REPROCESAR: 235,
}

export const TAB_SOLICITUDES = {
  SISTEMAS: 225,
  MATERIALES: 226,
  INCIDENTES: 227,
}

export const PERMISOS = [
  { name: 'alta', label: 'Alta', tooltip: "Permiso para creación" },
  { name: 'baja', label: 'Baja', tooltip: "Permiso para eliminación" },
  { name: 'modificacion', label: 'Modificación', tooltip: "Permiso para modificación" },
  { name: 'consulta', label: 'Consulta', tooltip: "Permiso a ver" },
  { name: 'total', label: 'Total', tooltip: "Permiso total (Ej: botones especiales, etc.)" },
];

export const ROL_COLORS = {
  1: "gold",
  2: "green",
  3: "blue",
  4: "magenta",
  5: "purple",
  6: "volcano",
};

export const TIPOS_ACCESOS_COLORS = {
  "menu": "gold",
  "interfaz": "green",
  "modulo": "blue",
  "button": "magenta",
  "tab": "purple",
  "new-element": "volcano",
};

export const TIPOS_SISTEMAS = {
  1: { nombre: "Administracion", color: "yellow" },
  2: { nombre: "Facturador", color: "lime" },
  3: { nombre: "App", color: "cyan" },
  4: { nombre: "Autogestion", color: "grey" },
};

export const EXCLUSIVE_URL = [
  "/",
  "/configuracion",
];